import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

var ChangeDefaultBodyModal = function (_super) {
  __extends(ChangeDefaultBodyModal, _super);

  function ChangeDefaultBodyModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    _this.saveLoading = false;
    _this.formData = {
      target_shop_code: undefined
    };
    _this.formDataRule = {
      target_shop_code: [{
        required: true,
        message: _this.t('请选择新绑定店铺'),
        trigger: 'change'
      }]
    };
    return _this;
  }

  ChangeDefaultBodyModal.prototype.onVisibleChange = function (value) {
    if (!value) {
      var formDataRef = this.$refs.formDataRef;
      this.formData = {
        target_shop_code: undefined
      };
      formDataRef && formDataRef.resetFields();
    }
  };

  ChangeDefaultBodyModal.prototype.formatCountryList = function (countryList) {
    if (countryList === void 0) {
      countryList = [];
    }

    return (countryList || []).map(function (item) {
      return item.country_code + " " + item.country_name;
    }).join('、');
  };

  ChangeDefaultBodyModal.prototype.handleOk = function () {
    var _this = this;

    var formDataRef = this.$refs.formDataRef;
    formDataRef.validate(function (valid) {
      return __awaiter(_this, void 0, void 0, function () {
        var code;

        var _a, _b;

        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (!valid) {
                return [2];
              }

              this.saveLoading = true;
              _c.label = 1;

            case 1:
              _c.trys.push([1,, 3, 4]);

              return [4, this.$api.shopManage.changeDefaultBody({
                country_code: (_b = (_a = this.record.country_list) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.country_code,
                target_shop_code: this.formData.target_shop_code
              })];

            case 2:
              code = _c.sent().code;

              if (code === 0) {
                this.$message.success(this.t('操作成功'));
                this.visible = false;
                this.$emit('success');
              }

              return [3, 4];

            case 3:
              this.saveLoading = false;
              return [7];

            case 4:
              return [2];
          }
        });
      });
    });
  };

  __decorate([Prop({
    type: Object,
    "default": function _default() {
      return {};
    }
  })], ChangeDefaultBodyModal.prototype, "record", void 0);

  __decorate([Prop({
    type: Array,
    "default": function _default() {
      return [];
    }
  })], ChangeDefaultBodyModal.prototype, "shopList", void 0);

  __decorate([Watch('visible')], ChangeDefaultBodyModal.prototype, "onVisibleChange", null);

  ChangeDefaultBodyModal = __decorate([Component], ChangeDefaultBodyModal);
  return ChangeDefaultBodyModal;
}(Vue);

export default ChangeDefaultBodyModal;